// A naptár tényadatai naptári elemekké alakítva. Minden elem a kezdetétől a végéig
// tart (a még tartó a jelen pillanatig), napokra bontva, hogy a napi oszlopokban
// a megfelelő helyen jelenjen meg.

export const ACTUAL_STYLES = {
  web: { color: "#3b82f6", label: "Phone login" },
  power: { color: "#64748b", label: "Tracker on" },
  tracker: { color: "#8b5cf6", label: "Tracker login" },
  cleaning: { color: "#14b8a6", label: "Cleaning" },
};

const CLEANING_DISPLAY_MINUTES = 15;

function startOfDay(time) {
  const d = new Date(time);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

function daySegments(start, end) {
  const segments = [];
  let dayStart = startOfDay(start);
  while (dayStart < end) {
    const nextDay = new Date(dayStart);
    nextDay.setDate(nextDay.getDate() + 1);
    const segStart = Math.max(start, dayStart);
    const segEnd = Math.min(end, nextDay.getTime());
    if (segEnd > segStart) segments.push([segStart, segEnd]);
    dayStart = nextDay.getTime();
  }
  return segments;
}

function spanEvents(type, id, title, detail, startIso, endIso, now, extra = {}) {
  const start = new Date(startIso).getTime();
  const end = endIso ? new Date(endIso).getTime() : now;
  if (!Number.isFinite(start) || end <= start) return [];
  return daySegments(start, end).map(([segStart, segEnd]) => ({
    id: `actual-${type}-${id}-${segStart}`,
    actual: true,
    actualType: type,
    title,
    detail,
    ongoing: !endIso,
    date: new Date(segStart).toISOString(),
    hasTime: true,
    dateOnly: false,
    estimated_minutes: (segEnd - segStart) / 60000,
    color: ACTUAL_STYLES[type].color,
    ...extra,
  }));
}

// Ugyanannak a trackernek / embernek az egymást folytató időszakai egy elemmé
// olvadnak (pl. tracker-újraindítás), így egy időben egy csíkja van.
function mergeContinuous(items, keyOf) {
  const byKey = new Map();
  items.forEach((item) => {
    const key = keyOf(item);
    byKey.set(key, [...(byKey.get(key) || []), item]);
  });
  const merged = [];
  byKey.forEach((list) => {
    const sorted = [...list].sort((a, b) => new Date(a.start) - new Date(b.start));
    sorted.forEach((item) => {
      const last = merged.length && merged[merged.length - 1].__key === keyOf(item) ? merged[merged.length - 1] : null;
      const lastEnd = last && (last.end ? new Date(last.end).getTime() : Infinity);
      if (last && lastEnd !== Infinity && new Date(item.start).getTime() - lastEnd <= 60000) {
        last.end = item.end;
      } else {
        merged.push({ ...item, __key: keyOf(item) });
      }
    });
  });
  return merged;
}

export function actualsToEvents(data, now = Date.now()) {
  if (!data) return [];
  return [
    ...mergeContinuous(data.web_sessions || [], (s) => `u${s.user_id}`).flatMap((s) => spanEvents(
      "web", s.id, s.user_name || "User", "Phone login", s.start, s.end, now, { user_id: s.user_id })),
    ...mergeContinuous(data.tracker_power || [], (s) => `d${s.device_id}`).flatMap((s) => spanEvents(
      "power", s.id, s.device_name || s.device_id, "Tracker on", s.start, s.end, now,
      { device_root_location_id: s.device_root_location_id })),
    ...mergeContinuous(data.tracker_sessions || [], (s) => `u${s.user_id}`).flatMap((s) => spanEvents(
      "tracker", s.id, s.user_name || "User", `Tracker login · ${s.device_name || s.device_id}`, s.start, s.end, now, { user_id: s.user_id })),
    ...(data.cleanings || []).map((c) => {
      // A takarítás a rögzítéskor eltárolt ideig tart; a loctag-beolvasás a közepére esik.
      const readTime = new Date(c.time).getTime();
      const durationMs = c.duration_seconds ? c.duration_seconds * 1000 : 0;
      return {
      id: `actual-cleaning-${c.id}`,
      actual: true,
      actualType: "cleaning",
      title: c.technical_location_name ? `${c.location_name} · ${c.technical_location_name}` : (c.location_name || "Cleaning"),
      detail: `Cleaning${c.user_name ? ` · ${c.user_name}` : ""}`,
      date: c.time,
      hasTime: true,
      dateOnly: false,
      estimated_minutes: CLEANING_DISPLAY_MINUTES,
      color: ACTUAL_STYLES.cleaning.color,
      root_location_id: c.root_location_id,
      user_id: c.user_id,
      marker: true,
      readTime,
      markerStart: readTime - durationMs / 2,
      markerMinutes: durationMs / 60000,
      };
    }),
  ];
}
